<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">manage_search</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Pesquisar cadastro</h2>
    @if (subtitulo) {
      <p class="modal-subtitle">{{ subtitulo }}</p>
    }
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar"
      (click)="fechar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<div class="campo">
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Pesquisar</mat-label>
    <input matInput [value]="termo" (input)="termo = $any($event.target).value"
      (keydown)="aoTeclar($event)" [placeholder]="placeholder">

    <button class="icon-mat-symbols-btn" matSuffix mat-icon-button type="button" [matMenuTriggerFor]="menuRefino"
      [class.refino-ativo]="refino" matTooltip="Refinar busca">
      <mat-icon class="material-symbols-outlined">tune</mat-icon>
    </button>

    <button class="icon-mat-symbols-btn" matSuffix mat-icon-button type="button" (click)="pesquisar()" matTooltip="Pesquisar">
      <mat-icon class="material-symbols-outlined">search</mat-icon>
    </button>
  </mat-form-field>

  <mat-menu #menuRefino="matMenu">
    <div class="menu-titulo">refinar busca</div>

    @for (opcao of opcoesRefino; track opcao.campo) {
      <button mat-menu-item type="button" [class.opcao-ativa]="refino?.campo === opcao.campo"
        (click)="escolherRefino(opcao)">
        {{ opcao.label }}
      </button>
    }

    <div class="menu-separador"></div>
    <button mat-menu-item type="button" class="opcao-limpar" (click)="escolherRefino(null)">
      Não refinar
    </button>
  </mat-menu>
</div>

<mat-dialog-content class="modal-content scroll-suave">
  @if (isBuscando && !resultados.length) {
    <div class="estado-central">
      <mat-spinner diameter="28"></mat-spinner>
    </div>
  } @else if (!jaPesquisou) {
    <div class="estado-central">
      <mat-icon class="material-symbols-outlined icone-grande">search</mat-icon>
      <p>Digite um termo e clique na lupa para pesquisar. Sem termo, a busca traz todos os cadastros.</p>
    </div>
  } @else if (!resultados.length) {
    <div class="estado-central">
      <mat-icon class="material-symbols-outlined icone-grande">person_off</mat-icon>
      <p>
        @if (termo) {
          Nenhum cadastro encontrado para "{{ termo }}". Tente outro termo ou refine a busca.
        } @else {
          Nenhum cadastro encontrado.
        }
      </p>
    </div>
  } @else {
    <div class="contagem">{{ contagem }}</div>

    <div class="lista">
      @for (item of resultados; track item.idPessoa) {
        <button type="button" class="linha" (click)="escolher(item)">
          <span class="avatar">{{ inicialDe(item) }}</span>

          <span class="linha-texto">
            <span class="linha-nome">{{ item.nome }}</span>
            @if (item.documento) {
              <span class="linha-detalhe">{{ item.documento | cpfCnpj }}</span>
            }
          </span>
        </button>
      }
    </div>

    @if (temMais) {
      <button mat-button type="button" class="btn-mais" [disabled]="isBuscando" (click)="verMais()">
        @if (isBuscando) {
          <mat-spinner diameter="16"></mat-spinner>
        } @else {
          Ver mais
        }
      </button>
    }
  }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button class="btn-secondary" (click)="fechar()">Cancelar</button>
</mat-dialog-actions>
